// This code forces the browser to reload the page when the user navigates back to it.

import {
  getLocalStorageWithExpiry,
  setLocalStorageWithExpiry,
} from "@/lib/utils/queryHelpers";

export const forceReloadOnChunkFailure = () => {
  console.error("forceReloadOnChunkFailure");
  if (!getLocalStorageWithExpiry("chunk_failed")) {
    setLocalStorageWithExpiry("chunk_failed", "true", 10000);
    window.location.reload();
  }
};
